module.exports = __webpack_public_path__ + "static/img/夏静.378b852.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teacher/夏静.jpg
// module id = ty5x
// module chunks = 139